<div class="bp-modal mod-lg wrapper">
	<bp-modal-header
		[title]="
			modalType === addressBookWalletViewType.WITHDRAW
				? ('send_via' | translate: [selectedCryptocoin?.name, selectedNetwork?.name])
				: null
		"
		class="font-semibold">
		<button class="cancel-button" left (click)="back()" (keydown.enter)="back()" [tabIndex]="0">
			<strong>{{ "back" | translate }}</strong>
		</button>
		<button class="cancel-button" right (click)="cancel()" (keydown.enter)="cancel()" [tabIndex]="0">
			<strong>{{ "cancel" | translate }}</strong>
		</button>
	</bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-description">
			<div class="header">
				<h2>{{ "address_book_owner_type_title" | translate }}</h2>
				<span class="title-description">
					{{ "address_book_owner_type_subtitle" | translate }}
					<a [href]="learnMoreUrl" target="_blank" class="learn-more-link">{{ "more_information" | translate }}</a>
				</span>
			</div>
		</div>

		<div class="bp-modal-body-section">
			<div class="recipient-options">
				<div class="recipient-option" (click)="selectOwnerType(ownerType.PERSON)" [tabIndex]="0" (keydown.enter)="selectOwnerType(ownerType.PERSON)">
					<div class="option-icon">
						<svg-inline src="assets/images/icons/person.svg" alt="" />
					</div>
					<div class="option-content">
						<h3 class="option-title">{{ "address_book_owner_type_person_title" | translate }}</h3>
						<p class="option-description">
							{{ "address_book_owner_type_person_subtitle" | translate }}
						</p>
					</div>
					<div class="option-arrow">
						<span class="bpi__icon-caret-right"></span>
					</div>
				</div>

				<div class="recipient-option" (click)="selectOwnerType(ownerType.LEGAL_ENTITY)" [tabIndex]="0" (keydown.enter)="selectOwnerType(ownerType.LEGAL_ENTITY)">
					<div class="option-icon">
						<svg-inline src="assets/images/icons/office.svg" alt="" />
					</div>
					<div class="option-content">
						<h3 class="option-title">{{ "address_book_owner_type_business_title" | translate }}</h3>
						<p class="option-description">
							{{ "address_book_owner_type_business_subtitle" | translate }}
						</p>
					</div>
					<div class="option-arrow">
						<span class="bpi__icon-caret-right"></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
